import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useSensitiveCitiesContext } from 'src/contexts/sensitive-cities.context';
import { actionTypes } from 'src/ducks/sensitive-cities.duck';
import { ISensitiveCities, ISensitiveCitiesForm } from 'src/models/sensitive-cities.model';
import { getSensitiveCitiesStatus } from 'src/selectors/sensitive-cities.selector';
import SensitiveCitiesForm from '../sensitive-cities-form/sensitive-cities-form.component';
import style from '../sensitive-cities-list/sensitive-cities-list.module.scss';

const SensitiveCitiesAdd: React.FC = () => {
  const { state, actions } = useSensitiveCitiesContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<ISensitiveCities> = {
    sensitiveCity: '',
    pamLead: '',
  };

  const addStatus = getSensitiveCitiesStatus(state, actionTypes.SENSITIVE_CITIES_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: ISensitiveCitiesForm = {
        sensitiveCity: data.sensitiveCity,
        pamLead: data.pamLead,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_SENSITIVE_CITY_ADD_SUCCESS,
            formData.sensitiveCity ? formData.sensitiveCity : data.sensitiveCity
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_SENSITIVE_CITIES}
      content={
        <div className={style.content}>
          <SensitiveCitiesForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default SensitiveCitiesAdd;
